import axios from 'axios';
import { LOGIN_USER, REGISTER_USER } from '../constants/users';

export const registerUser = (data) => (dispatch) => {
  dispatch({
    type: REGISTER_USER,
    payload: {
      loading: true,
      data: false,
      error: false,
      redirect: false
    }
  });

  axios
    .post('http://localhost:3004/users', data)
    .then((res) => {
      console.log('res:', res);
      dispatch({
        type: REGISTER_USER,
        payload: {
          loading: true,
          data: res.data,
          error: false,
          redirect: false
        }
      });
    })
    .catch((err) => {
      dispatch({
        type: REGISTER_USER,
        payload: {
          loading: false,
          data: false,
          error: err,
          redirect: false
        }
      });
    });
};

export const loginUser = (data) => ({
  type: LOGIN_USER,
  payload: {
    username: data.username,
    email: data.email,
    password: data.password
  }
});
